import { ApiStatus } from '../../../types';
import {
    docUploadDefaultAEM,
    DocUploadInitialState,
    DocUploadState,
} from './docUploadTypes';

export const defaultDocUploadInfo = {
    categories: [
        'mainIncome',
        'otherIncome',
        'nonCommbankLiabilities',
    ],
    maxFileSize: 2,
    minFileAllowed: 1,
    maxFileAllowed: 3,
    maxTotalFilesSize: 30,
    allowedFileFormats: [
        'tif',
        'pdf',
        'gif',
    ],
    categoriesRequired: [
        {
            categoryName: 'mainIncome',
            displayName: 'Main Income',
            data: [
                {
                    subCategory: 'employedFullTimeETJ',
                    subCategoryId: '78998',
                    id: '112345',
                    documentDisplayInfo: [
                        {
                            label: 'Business Name',
                            value: 'Commonwealth Bank',
                            type: 'string',
                        },
                        {
                            label: 'Income amount',
                            value: '5000',
                            type: 'currency',
                        },
                        {
                            label: 'Frequency',
                            value: 'Monthly',
                            type: 'frequency',
                        },
                    ],
                    documentTypes: [
                        {
                            id: '1001',
                            name: 'Recent Payslips',
                            docTipKey: 'payslips',
                        },
                        {
                            id: '1005',
                            name: 'Bank Statement Or Transaction Listings',
                            docTipKey: 'bankStatementOrTransactionListings_employed',
                        },
                    ],
                    uploadedFiles: [],
                    sessionInfo: [
                        {
                            sessionId: 0,
                            fileName: '',
                            description: '',
                            documentTypeId: '',
                            status: 0,
                            errorMsg: '',
                            progress: 0,
                        },
                    ],
                },
            ],
        },
        {
            categoryName: 'OtherIncome',
            displayName: 'Other Income',
            id: '12345',
            data: [
                {
                    subCategory: 'rentalIncome',
                    subCategoryId: '8998',
                    id: '122345',
                    documentDisplayInfo: [
                        {
                            label: 'Income type',
                            value: 'Rental income',
                            type: 'string',
                        },
                        {
                            label: 'Description',
                            value: '1 Locomotive St, South Eveleigh 2000',
                            type: 'string',
                        },
                        {
                            label: 'Income amount',
                            value: '1000',
                            type: 'currency',
                        },
                        {
                            label: 'Frequency',
                            value: 'Monthly',
                            type: 'frequency',
                        },
                    ],
                    documentTypes: [
                        {
                            id: '1001',
                            name: 'Recent Payslips',
                            docTipKey: 'payslips',
                        },
                        {
                            id: '1002',
                            name: 'Bank Statement',
                            docTipKey: 'bankStatement',
                        },
                        {
                            id: '1005',
                            name: 'Bank Statement Or Transaction Listings',
                            docTipKey: 'bankStatementOrTransactionListings',
                        },
                    ],
                    uploadedFiles: [],
                    sessionInfo: [{
                        sessionId: 0,
                        fileName: '',
                        description: '',
                        documentTypeId: '',
                        status: 0,
                        errorMsg: '',
                        progress: 0,
                    }],
                },
                {
                    subCategory: 'shares',
                    subCategoryId: '998',
                    id: '2345',
                    documentDisplayInfo: [
                        {
                            label: 'Income type',
                            value: 'Shares',
                            type: 'string',
                        },
                        {
                            label: 'Description',
                            value: 'ASX CBA',
                            type: 'string',
                        },
                        {
                            label: 'Income amount',
                            value: '1000',
                            type: 'currency',
                        },
                        {
                            label: 'Frequency',
                            value: 'Monthly',
                            type: 'frequency',
                        },
                    ],
                    documentTypes: [
                        {
                            id: '1001',
                            name: 'Recent Payslips',
                            docTipKey: 'payslips',
                        },
                        {
                            id: '1002',
                            name: 'Bank Statement',
                            docTipKey: 'bankStatementAndTaxDocument',
                        },
                    ],
                    uploadedFiles: [],
                    sessionInfo: [{
                        sessionId: 0,
                        fileName: '',
                        description: '',
                        documentTypeId: '',
                        status: 0,
                        errorMsg: '',
                        progress: 0,
                    }],
                },
            ],
        },
    ],
    docUploadContent: docUploadDefaultAEM,
};

const initialStateDocUpload: DocUploadInitialState = {
    applicationNumber: '',
    apiEndpoints: {
        updateDocUploadUrl: '/documents/uploadDocument',
        getDocUploadUrl: '/documents/getDocuments',
        submitDocUploadUrl: '/documents/complete',
    },
};

export const docUploadDefaultState: DocUploadState = {
    content: docUploadDefaultAEM,
    getDocInfoApiStatus: ApiStatus.Idle,
    docUploadApiStatus: ApiStatus.Idle,
    getDocUploadValidation: '',
    categories: [],
    mandatoryCategories: [],
    docUploadInfo: [],
    maxFileSize: 9,
    minFileAllowed: 1,
    maxFileAllowed: 20,
    maxTotalFilesSize: 30,
    allowedFileFormats: [],
    uploadedDocuments: [],
    docUploadBrowserStatus: ApiStatus.Idle,
    docUploadSubmitFromBrowserStatus: ApiStatus.Idle,
    ...initialStateDocUpload,
};
